import { CommonTrackingData, } from '@skoda/k2tools-app-services/lib/tracking'

export type ExternalTrackingData = { [key: string]: string };

export enum TrackingMatrix {
	pageView = '1',
	buttonClick = 5,
	orientationChange = 6,
	tabChange = 50,
	ctaClick = 17,
	video_interaction = 18,
	video_reach = 19
}

export class TrackingAppWebName {
	public static readonly orientationChange = 'orientation_change';
	public static readonly pageView = 'page_view';
	public static readonly virtualPageView = 'pageview';
	public static readonly buttonClick = 'button_click';
	public static readonly ctaClick = 'cta_click';
	public static readonly scrollDown = 'scroll_down';
	public static readonly slider = 'slider';
	public static readonly tooltipClick = 'tooltip_click';
	public static readonly tabChange = 'tab_change';
	public static readonly videoInteraction = 'video_interaction';
	public static readonly videoReach = 'video_reach';
}

export class TrackingConstants {
	public static readonly pageGroup = 'Availability List'
	public static readonly actionOrientationChange = 'Orientation change';
	public static readonly actionSearch = 'Search';
}

export interface FilterTrackingData {
	'filter.Country'?: string;
	'filter.Infotainment'?: string;
	'sc.FilterModel'?: string;
	'sc.FilterModelBody'?: string;
	'sc.FilterCarLine'?: string;
	'sc.DateOfProduction'?: string;
	'car.Country'?: string;
	'car.Infotainment'?: string;
	'car.Model'?: string;
}

export type TrackingObject = FilterTrackingData & CommonTrackingData;